<mat-expansion-panel
  class="gojs-legend"
  [ngClass]="position"
  [expanded]="expandLegend"
  (opened)="isPanelOpened = true"
  (closed)="isPanelOpened = false"
  hideToggle="true"
>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <span>
        <fa-icon class="fs-08 mr-1" [icon]="['fal', 'book-open']"></fa-icon>
        Legend
      </span>
      <fa-icon *ngIf="!isPanelOpened" class="fs-08" [icon]="['fal', 'chevron-up']"></fa-icon>
      <fa-icon *ngIf="isPanelOpened" class="fs-08" [icon]="['fal', 'chevron-down']"></fa-icon>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="py-1 flex flex-col">
    <div *ngFor="let legend of legendItems; trackBy: trackByValue" class="legend-item">
      <div class="legend-color" [style.background-color]="legend.color"></div>
      <img class="legend-icon" [src]="legend.icon" width="15" />
      <div class="legend-name">
        {{ legend.name }}
      </div>
    </div>
  </div>
</mat-expansion-panel>
